import { NormalizedSegment, LineTo, ClosePath } from '@tencent/alloy-renderer/dist/lib/path';
import { BorderSketchType } from '@src/slide/domain/ui-model/element-modeles/property/border/constants';
import { segmentType } from '@src/slide/domain/ui-model/element-modeles/property/border/sketch/path-processor/constants';

export function getSplitPath(segments: NormalizedSegment[], type: BorderSketchType, sizeFactor: number): string {
    let path = '';
    segments.forEach((segment) => {
        if (segment.cmd === segmentType.MoveTo) {
            path += `M ${segment.x} ${segment.y}`;
        } else if (segment.cmd === segmentType.LineTo) {
            path += splitLineToPath(segment, type, sizeFactor);
        } else if (segment.cmd === segmentType.CurveTo) {
            path += `${segment.cmd} ${segment.x1} ${segment.y1}, ${segment.x2} ${segment.y2}, ${segment.x} ${segment.y}`;
        } else if (segment.cmd === segmentType.QuadraticCurveTo) {
            path += `${segment.cmd} ${segment.x1} ${segment.y1}, ${segment.x} ${segment.y}`;
        } else if (segment.cmd === segmentType.ClosePath) {
            const { startX, startY, x, y } = segment;
            if (!(Math.round(startX) === Math.round(x) && Math.round(startY) === Math.round(y))) {
                path += splitLineToPath(segment, type, sizeFactor);
            }
            path += 'Z';
        }
    });
    return path;
}

function splitLineToPath(segment: LineTo | ClosePath, type: BorderSketchType, sizeFactor): string {
    let path = '';
    const maxLength = type === BorderSketchType.FREEHAND ? 150 * sizeFactor : 100 * sizeFactor;
    const { startX, startY, x, y } = segment;
    // 计算线条长度
    const lineLength = Math.sqrt(Math.pow((startX - x), 2) + Math.pow((startY - y), 2));
    // 线条需要被拆分成几段
    const count = Math.ceil(lineLength / maxLength);
    for (let i = 0; i < count; i++) {
        let x2;
        let y2;
        if (i === count - 1) {
            x2 = x;
            y2 = y;
        } else if (x === startX) {
            x2 = x;
            y2 = Math.round(((y - startY) / count) * (i + 1)) + startY;
        } else {
            x2 = Math.round(((x - startX) / count) * (i + 1)) + startX;
            y2 = Math.round((((x2 - startX) / (x - startX)) * (y - startY)) + startY);
        }
        path += ` L ${x2} ${y2}`;
    }
    return path;
}
